import { AbstractControl, FormArray, ValidatorFn } from '@angular/forms';

import { FeedAdviceType } from '../models/feed-advice.model';

const isEmptyObject = (obj: unknown): boolean =>
  obj && Object.keys(obj).length === 0 && obj.constructor === Object;

export const dayValidator =
  (
    element: string,
    dayFromArray: FormArray,
    dayToArray: FormArray,
    feedAdviceType: FeedAdviceType,
    transition: { day?: number },
  ): ValidatorFn =>
  (control: AbstractControl): { [key: string]: boolean } | null => {
    if (element === 'dayFrom') {
      const index = dayFromArray.controls.findIndex((x) => x === control) as number;
      if (index >= 0) {
        const dayToControl = dayToArray.controls[index];
        let dayToErrors = dayToControl.errors ? Object.assign({}, dayToControl.errors) : {};
        if (control.value) {
          if (
            (control.value as number) < (dayToControl.value as number) ||
            (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
              (control.value as number) < (dayToControl.value as number) &&
              (dayFromArray.controls[0].value as number) === transition?.day) ||
            (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
              dayFromArray.controls.some((x) => x.value === 1) &&
              (control.value as number) <= 115)
          ) {
            // validate this element in dayTo
            if (Object.prototype.hasOwnProperty.call(dayToErrors, 'day')) {
              delete dayToErrors.day;
            }
            dayToControl.setErrors(isEmptyObject(dayToErrors) ? null : dayToErrors);
            return null;
          } else {
            dayToErrors = { ...dayToErrors, day: false };
            dayToControl.setErrors(dayToErrors);
            return dayToErrors;
          }
        }
      }
    } else if (element === 'dayTo') {
      const index = dayToArray.controls.findIndex((x) => x === control) as number;
      if (index >= 0) {
        const dayFromControl = dayFromArray.controls[index];
        let dayFromErrors = dayFromControl.errors ? Object.assign({}, dayFromControl.errors) : {};
        if (control.value) {
          if (
            (feedAdviceType !== FeedAdviceType.SOWS_FARROWTOWEAN &&
              (control.value as number) >= (dayFromControl.value as number)) ||
            (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
              (control.value as number) <= 115 &&
              !dayFromArray.controls.some((x) => x.value === 1) &&
              (control.value as number) >= (dayFromControl.value as number)) ||
            (feedAdviceType === FeedAdviceType.SOWS_FARROWTOWEAN &&
              dayFromArray.controls.some((x) => x.value === 1) &&
              (control.value as number) >= (dayFromControl.value as number))
          ) {
            // validate this element in dayFrom
            if (Object.prototype.hasOwnProperty.call(dayFromErrors, 'day')) {
              delete dayFromErrors.day;
            }
            dayFromControl.setErrors(isEmptyObject(dayFromErrors) ? null : dayFromErrors);
            return null;
          } else {
            dayFromErrors = { ...dayFromErrors, day: false };
            dayFromControl.setErrors(dayFromErrors);
            return dayFromErrors;
          }
        }
      }
    }
  };
